"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Box = void 0;

var _primitives = require("../../platform/primitives");

var _styledSystem = require("styled-system");

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

/**
 * Box is just a `View` or `div` (depending on the platform) with common styled-systems
 * hooks.
 */
var Box = _primitives.styled.View(_templateObject(), _styledSystem.background, _styledSystem.bottom, _styledSystem.display, _styledSystem.height, _styledSystem.left, _styledSystem.maxWidth, _styledSystem.position, _styledSystem.right, _styledSystem.color, _styledSystem.space, _styledSystem.textAlign, _styledSystem.top, _styledSystem.width, _styledSystem.zIndex);

exports.Box = Box;
Box.displayName = "Box";
//# sourceMappingURL=Box.js.map